import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import FichasVentaReducer from './FichasVenta';
import ClientesReducer from './Clientes';
import ProformasReducer from './Proformas';
import UsosReducer from './Usos';
import CondicionesReducer from './Condiciones';
import ColoresReducer from './Colores';
import AutorizacionesReducer from './Autorizaciones';
import AutorizacionesExcepcionalesReducer from './AutorizacionesExcepcionales';
import FacturacionElectronicaReducer from './FacturacionElectronica';
import CompaniasReducer from './Companias';
import AreasVentaReducer from './AreasVenta';
import EstadosReducer from './Estados';
import FamiliasReducer from './Familias';
import FilialesReducer from './Filiales';
import ZonasReducer from './Zonas';
import TipoFichaReducer from './TipoFichas';
import MonedasReducer from './Monedas';
import TipoPagosReducer from './TipoPagos';
import TipoAdquisicionReducer from './TipoAdquisicion';
import VendedoresReducer from './Vendedores';
import FichasEntregaReducer from './FichasEntrega';
import MarcasReducer from './Marcas';
import EstadoPedidoReducer from './EstadoPedido';
import EstadoCancelacionReducer from './EstadoCancelacion';
import EstadoGeneralPlanificacionReducer from './EstadoGeneralPlanificacion';
import EstadoGeneralTransportistaReducer from './EstadoGeneralTransportista';
import EstadoGeneralTipoPlacaReducer from './EstadoGeneralTipoPlaca';
import EstadoGeneralTipoEntregaReducer from './EstadoGeneralTipoEntrega';
import FichaEntregaGetReducer from './FichaEntregaGet';
import EstadoGeneralLugarEntregaReducer from './EstadoGeneralLugarEntrega';
import EstadoGeneralMotivoRechazoReducer from './EstadoGeneralMotivoRechazo';
import PedidosReducer from './Pedidos';
import HistorialReducer from './Historial';
import ColaboradoresReducer from './Colaboradores';
import ProgramarplanificacionReducer from './ProgramacionPlanificacion';
import ReprogramarplanificacionReducer from './ReprogramacionPlanificacion';
import AdpersonasReducer from './Adpersonas';
import entregaFilialReducer from './Entregafilial';
import listapogramadasReduccer from './listaProgramacion';
import IndicadoresEntregas from './IndicadoresEntregas';
import FichasEntregaDescarga from './FichasEntregaDescarga';
import programacionCalendario from './programacionCalendario';
import diasEntregaReduccer from './diasEntrega';
import TipoAutorizacionReducer from './TipoAutorizacion';
import ResponsablesReducer from './Responsables';
import MantenimientoEntregaReducer from './MantenimientoEntrega';
import MantenimientoSkuVehiculoReducer from './MantenimientoSkuVehiculo';
import CapacitacionReducer from './Capacitacion';
import ArchivosAdjuntosReducer from './ArchivosAdjuntos';
import FinanciamientoReducer from './Financiamiento';
import FacturacionReducer from './Facturacion';
import ProveedorCarroceroReducer from './ProveedorCarrocero';
import SucursalReducer from './Sucursales';
import BonosReducer from './Bonos';
import EntidadFinancieraReducer from './EntidadFinanciera';
import FormaPagoReducer from './FormaPago';
import TipoDocumentoReducer from './TipoDocumento';
import PedidosBuscarReducer from './PedidosBuscar';
import GestionCostoReducer from './GestionCosto';
import InmatriculacionReducer from './Inmatriculacion';
import ProveedorEquiposAdicionesReducer from './ProveedorEquiposAdicionales';
import TipoAdicionalReducer from './TipoAdicional';
import ProformasBuscarReducer from './ProformasBuscar';
import equiposLogisticaReducer from './EquiposLogistica';
import ReporteReducer from './Reporte';
import EquiposCortesiaReducer from './EquiposCortesia';
import DireccionesReducer from './Direcciones';
import MaestroGenericoTipoSolicitudReducer from './MaestroGenerico';
import ContactosClientesFacturacionReducer from './ContactosClientesFacturacion';
import PedidosColoresReducer from './PedidosColores';
import SeguimientoAutorizacionesReducer from './SeguimientoAutorizaciones';
import AsginacionDefinitivaReducer from './AsginacionDefinitiva'
import GenerarCorreoAutorizacionesReducer from './GenerarCorreoAutorizaciones'
import ReglasNegocioReducer from './ReglasNegocio'
import SolicitudAutorizacionPedidosReducer from './SolicitudAutorizacionPedidos'
import LogisticaCostoReducer from './LogisticaCosto'
import MantMaestrosReducer from './MantMaestros';
import PermisosReducer from "./Permisos";

const rootReducer = combineReducers({
  fichasVenta: FichasVentaReducer,
  clientes: ClientesReducer,
  proformas: ProformasReducer,
  proformasBuscar: ProformasBuscarReducer,
  form: formReducer,
  usos: UsosReducer,
  condiciones: CondicionesReducer,
  colores: ColoresReducer,
  autorizaciones: AutorizacionesReducer,
  autorizacionesExcepcionales: AutorizacionesExcepcionalesReducer,
  facturacionElectronica: FacturacionElectronicaReducer,
  companias: CompaniasReducer,
  areasVenta: AreasVentaReducer,
  estados: EstadosReducer,
  familias: FamiliasReducer,
  filiales: FilialesReducer,
  zonas: ZonasReducer,
  tipoFichas: TipoFichaReducer,
  monedas: MonedasReducer,
  tipoPagos: TipoPagosReducer,
  tipoAdquisicion: TipoAdquisicionReducer,
  tipoAutorizacion: TipoAutorizacionReducer,
  vendedores: VendedoresReducer,
  fichasEntrega: FichasEntregaReducer,
  marcas: MarcasReducer,
  estadoPedido: EstadoPedidoReducer,
  estadoCancelacion: EstadoCancelacionReducer,
  estadoGeneralPlanificacion: EstadoGeneralPlanificacionReducer,
  estadoGeneralTransportista: EstadoGeneralTransportistaReducer,
  estadoGeneralTipoPlaca: EstadoGeneralTipoPlacaReducer,
  estadoGeneralTipoEntrega: EstadoGeneralTipoEntregaReducer,
  fichasEntregaGet: FichaEntregaGetReducer,
  estadoGeneralLugarEntrega: EstadoGeneralLugarEntregaReducer,
  estadoGeneralMotivoRechazo: EstadoGeneralMotivoRechazoReducer,
  pedidos: PedidosReducer,
  pedidosBuscar: PedidosBuscarReducer,
  historial: HistorialReducer,
  colaboradores: ColaboradoresReducer,
  planificar: ProgramarplanificacionReducer,
  replanificar: ReprogramarplanificacionReducer,
  Adpersonas: AdpersonasReducer,
  listaentregaFilial: entregaFilialReducer,
  listaProgramacion: listapogramadasReduccer,
  indicadoresEntregas: IndicadoresEntregas,
  fichasEntregaDescarga: FichasEntregaDescarga,
  listaCalendario: programacionCalendario,
  diaEntrega: diasEntregaReduccer,
  responsables: ResponsablesReducer,
  mantenimientoEntrega: MantenimientoEntregaReducer,
  mantenimientoSkuVehiculo: MantenimientoSkuVehiculoReducer,
  archivosAdjuntos: ArchivosAdjuntosReducer,
  financiamiento: FinanciamientoReducer,
  capacitacion: CapacitacionReducer,
  facturacion: FacturacionReducer,
  proveedorCarrocero: ProveedorCarroceroReducer,
  sucursales: SucursalReducer,
  bonos: BonosReducer,
  equiposLogistica: equiposLogisticaReducer,
  entidadFinanciera: EntidadFinancieraReducer,
  formaPago: FormaPagoReducer,
  tipoDocumento: TipoDocumentoReducer,
  gestionCosto: GestionCostoReducer,
  inmatriculacion: InmatriculacionReducer,
  proveedorEquposAdicionales: ProveedorEquiposAdicionesReducer,
  tipoAdicional: TipoAdicionalReducer,
  reporte: ReporteReducer,
  equiposCortesia: EquiposCortesiaReducer,
  direcciones: DireccionesReducer,
  maestroGenericoTipoSolicitud:MaestroGenericoTipoSolicitudReducer,
  contactosClientesFacturacionReducer:ContactosClientesFacturacionReducer,
  pedidosColores:PedidosColoresReducer,
  seguimientoAutorizaciones:SeguimientoAutorizacionesReducer,
  asginacionDefinitivaRP:AsginacionDefinitivaReducer,
  generarCorreoAutorizaciones:GenerarCorreoAutorizacionesReducer,
  reglasNegocio:ReglasNegocioReducer,
  solicitudPedidos:SolicitudAutorizacionPedidosReducer,
  logisticaCosto:LogisticaCostoReducer,
  maestros: MantMaestrosReducer,
  permisos:PermisosReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js